import { ApiBase } from "@/api/ApiBase";

export interface EstabelecimentoResumo {
  codigo: string;
  endereco: string;
  municipio: string;
  numero: string;
  provincia: string;
  estado: "Activo" | "Inactivo";
  dataCriacao: string;
  nome: string;
}

export interface DadosEstabelecimentoForm {
  nome: string;
  numero: string;
  estado: "Activo" | "Inactivo";
  provincia: string;
  municipio: string;
  endereco: string;
}

export interface EditarApagarEstabelecimentoResponse {
  msg: string;
  tipo: "sucesso" | "erro";
}

export class EstabelecimentosApi extends ApiBase {
  listar(): Promise<EstabelecimentoResumo[]> {
    return this.http.put<EstabelecimentoResumo[]>(
      "/api/comerciante/estabelecimento/lista-by-comerciante",
    );
  }

  private construirDados(
    dados: DadosEstabelecimentoForm,
    codigoExistente?: string,
  ): Record<string, string> {
    const params: Record<string, string> = {
      nome: dados.nome,
      numero: dados.numero,
      estado: dados.estado,
      provincia: dados.provincia,
      municipio: dados.municipio,
      endereco: dados.endereco,
    };
    if (codigoExistente) params.codigo = codigoExistente;
    return params;
  }

  adicionar(
    dados: DadosEstabelecimentoForm,
  ): Promise<EditarApagarEstabelecimentoResponse> {
    return this.http.post<EditarApagarEstabelecimentoResponse>(
      "/api/comerciante/estabelecimento/add",
      this.construirDados(dados),
    );
  }

  editar(
    codigo: string,
    dados: DadosEstabelecimentoForm,
  ): Promise<EditarApagarEstabelecimentoResponse> {
    return this.http.post<EditarApagarEstabelecimentoResponse>(
      "/api/comerciante/estabelecimento/edit",
      this.construirDados(dados, codigo),
    );
  }

  apagar(codigo: string): Promise<EditarApagarEstabelecimentoResponse> {
    return this.http.post<EditarApagarEstabelecimentoResponse>(
      "/api/comerciante/estabelecimento/delete",
      { codigo },
    );
  }
}
